/* ── Navbar — source unique de vérité ─────────────────────────
   Hauteur de la navbar fixe, réutilisée par le composant lui-même
   et par toutes les sections "hero" qui doivent passer dessous
   (via `margin-top: -${NAV_HEIGHT}px` pour annuler le padding-top
   global posé par PageLayout). ────────────────────────────────── */
export const NAV_HEIGHT = 44;
